import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "py-10 relative" }
const _hoisted_2 = { class: "max-w-7xl mx-auto" }
const _hoisted_3 = { class: "text-3xl font-bold text-white" }
const _hoisted_4 = { class: "text-sm text-white max-w-3xl mt-1" }
const _hoisted_5 = { class: "flex items-start justify-between" }
const _hoisted_6 = { class: "w-1/3 bg-white rounded-lg py-4 px-6" }
const _hoisted_7 = { class: "max-w-md mx-auto" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl leading-6 font-bold text-gray-900" }, "Your path to a better, smarter commercial mortgage", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal text-gray-500 mt-2" }, " After processing billions of dollars of loans from tens of thousands of borrowers, we've got this down to a science. ", -1)
const _hoisted_10 = {
  "aria-label": "Progress",
  class: "mt-6"
}
const _hoisted_11 = {
  role: "list",
  class: "overflow-hidden"
}
const _hoisted_12 = { class: "h-9 flex items-center" }
const _hoisted_13 = {
  key: 0,
  class: "relative z-10 w-8 h-8 flex items-center justify-center bg-sky rounded-full group-hover:bg-indigo-800"
}
const _hoisted_14 = {
  key: 1,
  class: "relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-sky rounded-full"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "h-2.5 w-2.5 bg-sky rounded-full" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full group-hover:border-gray-400"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "ml-4 min-w-0 flex flex-col" }
const _hoisted_21 = { class: "text-xs text-gray-500" }
const _hoisted_22 = { class: "w-2/3 pl-6" }
const _hoisted_23 = {
  key: 0,
  class: "text-sm leading-5 font-normal text-gray-500 -mt-4 mb-6"
}
const _hoisted_24 = {
  key: 0,
  class: "flex flex-wrap"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 2,
  class: "w-1/2 lg:1/3 pr-2 relative max-w-xs"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "$")
], -1)
const _hoisted_28 = { class: "w-1/2 pr-1" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "block text-sm font-medium text-gray-700"
}, " First name ", -1)
const _hoisted_30 = { class: "mt-2" }
const _hoisted_31 = { class: "w-1/2 pl-1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "block text-sm font-medium text-gray-700"
}, " Last name ", -1)
const _hoisted_33 = { class: "mt-2" }
const _hoisted_34 = { class: "w-1/2 pr-1 mt-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-gray-700"
}, " Corporate email ", -1)
const _hoisted_36 = { class: "mt-2" }
const _hoisted_37 = { class: "w-1/2 pl-1 mt-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "block text-sm font-medium text-gray-700"
}, " Phone ", -1)
const _hoisted_39 = { class: "mt-2" }
const _hoisted_40 = {
  key: 1,
  class: "flex justify-start items-center w-full"
}
const _hoisted_41 = {
  for: "dropzone-file",
  class: "flex flex-col justify-center items-center w-1/2 h-36 bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
}
const _hoisted_42 = { class: "flex flex-col justify-center items-center pt-6 pb-6" }
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<svg class=\"mb-3 w-10 h-10 text-gray-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12\"></path></svg><p class=\"mb-2 text-sm text-gray-500 dark:text-gray-400\"><span class=\"font-semibold\">Click to upload</span> or drag and drop</p><p class=\"text-xs text-gray-500 dark:text-gray-400\">MAX. 20MB</p>", 3)
const _hoisted_46 = {
  key: 1,
  class: "text-sm text-gray-500 dark:text-gray-400"
}
const _hoisted_47 = { class: "font-semibold" }
const _hoisted_48 = ["onInput"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 2,
  class: "flex flex-wrap"
}
const _hoisted_52 = {
  key: 0,
  class: "py-2 px-4 rounded-md mr-2 mb-2 cursor-pointer text-sm bg-gray-100 text-dark"
}
const _hoisted_53 = {
  key: 1,
  class: "py-2 px-4 rounded-md mr-2 mb-2 cursor-pointer text-sm bg-blue-200 text-sky"
}
const _hoisted_54 = {
  key: 2,
  class: "py-2 px-4 rounded-md mr-2 mb-2 cursor-pointer text-sm bg-blue-200 text-sky"
}
const _hoisted_55 = {
  key: 3,
  class: "py-2 px-4 rounded-md mr-2 mb-2 cursor-pointer text-sm bg-blue-200 text-sky"
}
const _hoisted_56 = {
  key: 1,
  class: "bg-white rounded-lg shadow-sm px-6 py-10 flex flex-col justify-center items-center"
}
const _hoisted_57 = { class: "w-12 h-12 bg-green-200 text-green-500 flex items-center justify-center rounded-full mb-4" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl leading-8 font-bold mb-2 text-sky text-center" }, "Joe will be your personal capital markets advisor", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal text-gray-500 text-center mb-8" }, "He'll be reviewing and optimizing your loan package and present it to the best of the XX matched lenders, to get your perfect quotes.", -1)
const _hoisted_60 = { class: "flex justify-between items-center" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-20 h-20 rounded-md mr-6",
  style: {"background-image":"url(/media/joe.jpg)","background-size":"cover","background-position":"center"}
}, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "text-base leading-6 font-semibold text-sky" }, "Joe Nolan", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-medium text-gray-700" }, "Advisor, Janover Ventures", -1)
const _hoisted_64 = { class: "flex items-center mt-2" }
const _hoisted_65 = { class: "flex px-2 py-1 border rounded-md items-center text-sm mr-1 cursor-pointer" }
const _hoisted_66 = { class: "flex px-2 py-1 border rounded-md items-center text-sm cursor-pointer" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs leading-4 font-normal text-center mt-8 max-w-md text-gray-500" }, " Expect him to be in touch with you within 24 (working) hours with more information. You'll also be able to check back here for updates and we'll keep you posted on email too! ", -1)
const _hoisted_68 = {
  key: 2,
  class: "bg-white rounded-lg shadow-sm mt-6"
}
const _hoisted_69 = /*#__PURE__*/_createStaticVNode("<div class=\"p-6\"><p class=\"text-2xl leading-8 font-bold mb-3 text-sky\">How do you like the process so far?</p><p class=\"text-sm leading-5 font-normal text-gray-500\">Help us become better :)</p></div><div class=\"px-6 py-4 bg-gray-200 flex items-center\"><div class=\"py-2 px-5 border rounded-md mr-2 cursor-pointer mr-2 bg-white\"> Perfect so far! </div><div class=\"py-2 px-5 border rounded-md mr-2 cursor-pointer mr-2 bg-white\"> It’s ok </div><div class=\"py-2 px-5 border rounded-md mr-2 cursor-pointer bg-white\"> There’s a room to improve </div></div>", 2)
const _hoisted_71 = [
  _hoisted_69
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_ArrowNarrowDownIcon = _resolveComponent("ArrowNarrowDownIcon")!
  const _component_PhoneIcon = _resolveComponent("PhoneIcon")!
  const _component_MailIcon = _resolveComponent("MailIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.name), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.updated), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("nav", _hoisted_10, [
            _createElementVNode("ol", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav, ({ title, subtitle, key }, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: _normalizeClass(["relative", { 'pb-10': index < _ctx.nav.length - 1 }])
                }, [
                  (index < _ctx.nav.length - 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full", { 'bg-sky': _ctx.stepCompleted(key), 'bg-gray-300': !_ctx.stepCompleted(key) }]),
                        "aria-hidden": "true"
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                    class: "relative flex items-start group"
                  }, [
                    _createElementVNode("span", _hoisted_12, [
                      (_ctx.stepCompleted(key))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _createVNode(_component_CheckIcon, { class: "w-5 h-5 text-white" })
                          ]))
                        : (_ctx.stepActive(key))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_16))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, _hoisted_19))
                    ]),
                    _createElementVNode("span", _hoisted_20, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["text-xs font-semibold tracking-wide uppercase", { 'text-sky': _ctx.stepCompleted(key) || _ctx.stepActive(key), 'text-gray-600': !_ctx.stepCompleted(key) && !_ctx.stepActive(key) }])
                      }, _toDisplayString(title), 3),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(subtitle), 1)
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        (!_ctx.hideQuiz)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.visibleSteps, ({
            title,
            options,
            isActive,
            isCompleted,
            nextStep,
            type,
            subtitle
          }, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["block p-6 rounded-md shadow-sm bg-white mb-4 max-w-5xl", { 'pointer-events-none opacity-20': !isActive }]),
                key: key
              }, [
                (type !== 'submit')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("h3", {
                        class: _normalizeClass({
                'text-lg leading-6 font-medium mb-4': isCompleted,
                'text-xl leading-7 font-medium mb-6': !isCompleted
              })
                      }, _toDisplayString(title), 3),
                      (subtitle && !isCompleted)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(subtitle), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (isActive && !isCompleted)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (type !== 'document')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            (type == 'selector')
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(options, (option, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(["py-2 px-5 border rounded-md mr-2 mb-2 cursor-pointer", { 'bg-gray-200 border-gray-200': _ctx.steps[key].collectedData && _ctx.steps[key].collectedData == option }]),
                                    key: index,
                                    onClick: ($event: any) => (_ctx.updateValue(key, option))
                                  }, _toDisplayString(option), 11, _hoisted_25))
                                }), 128))
                              : _createCommentVNode("", true),
                            (type == 'address')
                              ? (_openBlock(), _createBlock(_component_GMapAutocomplete, {
                                  key: 1,
                                  placeholder: "Start typing...",
                                  options: {
                    componentRestrictions: { country: 'us' }
                  },
                                  class: "border rounded-md h-10 max-w-xs w-full text-sm px-3",
                                  onPlace_changed: _ctx.saveAddress
                                }, null, 8, ["onPlace_changed"]))
                              : _createCommentVNode("", true),
                            (type == 'loanAmount')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _hoisted_27,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "border rounded-md h-10 w-full text-sm px-3 pl-6",
                                    id: "minimumAmount",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.steps.loanAmount.collectedData.loanAmount) = $event)),
                                    placeholder: " Loan amount"
                                  }, null, 512), [
                                    [_vModelText, _ctx.steps.loanAmount.collectedData.loanAmount]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (type == 'contacts')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createElementVNode("div", _hoisted_28, [
                                    _hoisted_29,
                                    _createElementVNode("div", _hoisted_30, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        name: "firstName",
                                        id: "firstName",
                                        class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
                                        placeholder: "David",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.steps.contacts.collectedData.firstName) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.steps.contacts.collectedData.firstName]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_31, [
                                    _hoisted_32,
                                    _createElementVNode("div", _hoisted_33, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        name: "lastName",
                                        id: "lastName",
                                        class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
                                        placeholder: "Miller",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.steps.contacts.collectedData.lastName) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.steps.contacts.collectedData.lastName]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_34, [
                                    _hoisted_35,
                                    _createElementVNode("div", _hoisted_36, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        name: "email",
                                        id: "email",
                                        class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
                                        placeholder: "david.miller@company.com",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.steps.contacts.collectedData.email) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.steps.contacts.collectedData.email]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_37, [
                                    _hoisted_38,
                                    _createElementVNode("div", _hoisted_39, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        name: "phone",
                                        id: "phone",
                                        class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
                                        placeholder: "(305) 264-43-33",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.steps.contacts.collectedData.phone) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.steps.contacts.collectedData.phone]
                                      ])
                                    ])
                                  ])
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                        : (type == 'document')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createElementVNode("label", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  (!_ctx.steps[key].collectedData)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_43
                                      ], 64))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_46, [
                                        _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.steps[key].collectedData), 1)
                                      ]))
                                ]),
                                _createElementVNode("input", {
                                  id: "dropzone-file",
                                  type: "file",
                                  class: "hidden",
                                  onInput: ($event: any) => (_ctx.handleFileInput(key, $event))
                                }, null, 40, _hoisted_48)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex items-center justify-start mt-4", { 'mt-6': ['loanAmount', 'propertyAddress'].includes(type) }])
                      }, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["h-10 bg-sky text-white rounded-md w-24 flex justify-center items-center", { 'pointer-events-none opacity-50': !_ctx.validSteps[key] }]),
                          onClick: ($event: any) => (_ctx.processNextStep(key, nextStep))
                        }, [
                          _createTextVNode(" Next "),
                          (type !== 'contacts')
                            ? (_openBlock(), _createBlock(_component_ArrowNarrowDownIcon, {
                                key: 0,
                                class: "w-4 h-4 ml-3 -mr-1"
                              }))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_49),
                        (!['loanAmount', 'propertyType', 'loanType'].includes(key))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "ml-4 text-sm text-gray-500",
                              href: "#skip",
                              onClick: _withModifiers(($event: any) => (_ctx.skip(key, nextStep)), ["prevent"])
                            }, " Skip ", 8, _hoisted_50))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 64))
                  : _createCommentVNode("", true),
                isCompleted
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      (_ctx.steps[key].collectedData == 'Skipped')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, " Skipped "))
                        : (type == 'selector' || type == 'document' || type == 'address')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.steps[key].collectedData), 1))
                          : _createCommentVNode("", true),
                      (type == 'loanAmount')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, " $" + _toDisplayString(_ctx.convertToShortCurrency(_ctx.steps.loanAmount.collectedData.loanAmount)), 1))
                        : _createCommentVNode("", true),
                      (type == 'contacts')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, " Submitted "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.showAdvisor)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_CheckIcon, { class: "w-5 h-5" })
              ]),
              _hoisted_58,
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _createElementVNode("div", null, [
                  _hoisted_62,
                  _hoisted_63,
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createVNode(_component_PhoneIcon, { class: "w-3 h-3 mr-1" }),
                      _createTextVNode(" Schedule a call ")
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _createVNode(_component_MailIcon, { class: "w-3 h-3 mr-1" }),
                      _createTextVNode(" Email ")
                    ])
                  ])
                ])
              ]),
              _hoisted_67,
              _createVNode(_component_router_link, {
                to: "/borrower-dashboard",
                class: "flex items-center text-base leading-6 font-medium text-sky-300 mt-10"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Return to your dashboard ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.hideQuiz)
          ? (_openBlock(), _createElementBlock("div", _hoisted_68, _hoisted_71))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}